import { Fragment } from "react"

interface CompactStepIndicatorProps {
    activeStep: number
    steps: {
        label: string
        key: number
    }[]
}

const CompactStepIndicator = ({ activeStep, steps }: CompactStepIndicatorProps) => {
    return (
        <div className="w-fit flex flex-wrap items-center py-1 gap-4  ">
            {steps.map((step, index) => (
                <Fragment key={step.key}>
                    <div className="flex items-center">
                        <div className="flex flex-col items-start">
                            <div className="flex items-center">
                                <div
                                    className={`w-3 h-3 rounded-full mr-2 ${step.key <= activeStep ? "bg-primary" : "bg-gray-200 border border-gray-300"
                                        }`}
                                ></div>
                                <span className={`text-xs font-medium ${step.key <= activeStep ? "text-gray-700" : "text-gray-400"}`}>
                                    {step.label}
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* {index < steps.length - 1 && (
                        <div
                            className={`flex-grow mx-2 h-[1px] ${step.key < activeStep && steps[index + 1].key <= activeStep ? "bg-green-500" : "bg-gray-200"
                                }`}
                        ></div>
                    )} */}
                </Fragment>
            ))}
        </div>
    )
}

export default CompactStepIndicator


